<template>
  <div>
    <div class="list list-spaced rounded">
      <slot name="before" />

      <div v-if="loading" class="text-center bg-gray-200">
        <Loader />
      </div>
      <TaskLine
        ref="taskLines"
        v-for="task in tasks"
        :key="task.uuid"
        :task="task"
        :member-options="memberOptions"
        @focusing="blurTasks"
      />

      <div v-if="!loading && tasks.length === 0" class="bg-gray-200 p-6 text-center">
        There are no tasks yet. Create your first task!
      </div>
    </div>
  </div>
</template>

<script>
import TaskLine from './TaskLine.vue';

export default {
  components: {
    TaskLine,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
    memberOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    tasks() {
      return this.$store.getters['ui/contactRequestTasks/itemsByParent'](this.contactRequest.id);
    },
  },
  created() {
    this.fetchTasks();
  },
  destroyed() {
    this.$store.dispatch('ui/contactRequestTasks/clearByParent', {
      parentId: this.contactRequest.id,
    });
  },
  methods: {
    async fetchTasks() {
      try {
        this.loading = true;

        await this.$store.dispatch('ui/contactRequestTasks/load', {
          id: this.contactRequest.id,
          query: {
            include: 'user',
          },
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    blurTasks() {
      const { taskLines = [] } = this.$refs;

      taskLines.forEach((taskLine) => {
        taskLine.blur();
      });
    },
  },
  provide() {
    return {
      refreshTasks: this.fetchTasks,
    };
  },
};
</script>
